import React from 'react';

import cx from 'classnames';

import { getCityCodeFormat, getMinutesAndHoursFormat } from 'components/Pages/Admin/GuestPortal/Flights/utils';

import { Head } from './Head';
import s from './index.module.css';

export function Item({ item, activeType, setActiveItems, checked }) {
  const { arrivalAirport, departureAirport, departureTime, arrivalTime, airline } = item;

  return (
    <div className={cx(s.wrapper, 'custom-add-flights-result-wrapper')}>
      <Head activeType={activeType} setActiveItems={setActiveItems} item={item} checked={checked} />

      <div className={cx(s.blocks, 'custom-add-flights-result-blocks')}>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Estimated Departure Time:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>
            {getMinutesAndHoursFormat(new Date(departureTime), departureAirport?.utcOffsetHours)}
          </strong>
        </div>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Estimated Arrival Time:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>
            {getMinutesAndHoursFormat(new Date(arrivalTime), arrivalAirport?.utcOffsetHours)}
          </strong>
        </div>
      </div>

      <div className={cx(s.blocks, 'custom-add-flights-result-blocks')}>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Departure Airport:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>{departureAirport?.fsCode}</strong>
        </div>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Arrival Airport:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>{arrivalAirport?.fsCode}</strong>
        </div>
      </div>

      <div className={cx(s.blocks, 'custom-add-flights-result-blocks')}>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Departure City:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>
            {`${departureAirport?.city} ${getCityCodeFormat(departureAirport?.cityCode)}`}
          </strong>
        </div>
        <div className={cx(s.block, 'custom-add-flights-result-block')}>
          <div className={cx(s.label, 'custom-add-flights-result-label')}>Arrival City:</div>
          <strong className={cx(s.value, 'custom-add-flights-result-value')}>
            {`${arrivalAirport?.city} ${getCityCodeFormat(arrivalAirport?.cityCode)}`}
          </strong>
        </div>
      </div>

      <div className={cx(s.blocks, 'custom-add-flights-result-blocks')}>
        {airline && (
          <div className={cx(s.block, 'custom-add-flights-result-block')}>
            <div className={cx(s.label, 'custom-add-flights-result-label')}>Airline:</div>
            <strong className={cx(s.value, 'custom-add-flights-result-value')}>{airline.name}</strong>
          </div>
        )}
      </div>

      {/* <div className={s.blocks}>
        <div className={s.block}>
          <div className={s.label}>Status:</div>
          <strong className={s.value}>On Time</strong>
        </div>
      </div> */}
    </div>
  );
}

{
  /* <div className={s.head}>
        <CheckBox
          onChange={() => setActiveItemIds({ details: fake })}
          checked={Boolean(activeItemIds?.details)}
          titleClassName={s.checkbox}
        >
          <strong>Flight DL2238</strong> on <strong>March 24, 2021</strong>
        </CheckBox>
      </div>

      <div className={s.blocks}>
        <div className={s.block}>
          <div className={s.label}>Estimated departure time:</div>
          <strong className={s.value}>{fake.departs.departureTime}</strong>
        </div>
        <div className={s.block}>
          <div className={s.label}>Estimated Arrival Time:</div>
          <strong className={s.value}>{fake.arrives.arrivalTime}</strong>
        </div>
      </div>

      <div className={s.blocks}>
        <div className={s.block}>
          <div className={s.label}>Departure Airport:</div>
          <strong className={s.value}>{fake.from}</strong>
        </div>
        <div className={s.block}>
          <div className={s.label}>Arrival Airport:</div>
          <strong className={s.value}>{fake.arrives.to}</strong>
        </div>
      </div>

      <div className={s.blocks}>
        <div className={s.block}>
          <div className={s.label}>Departure City:</div>
          <strong className={s.value}>New York City (NYC)</strong>
        </div>
        <div className={s.block}>
          <div className={s.label}>Arrival City:</div>
          <strong className={s.value}>Los Angeles (LA)</strong>
        </div>
      </div>

      <div className={s.blocks}>
        <div className={s.block}>
          <div className={s.label}>Status:</div>
          <strong className={s.value}>On Time</strong>
        </div>
      </div> */
}
